import React from "react";
import { FormControl, InputLabel, Select, MenuItem, ListSubheader } from "@material-ui/core";
import { Field } from "react-final-form";

import withStyles from "@material-ui/styles/withStyles";
import { styles } from "./GroupSelect.styles";

import MetaError from "./MetaError";

function GroupSelect({ classes, id, label, options }) {
  return (
    <div className={classes.root}>
      <Field name={id}>
        {({ input, meta }) => {
          return (
            <div>
              <FormControl className={classes.formControl} fullWidth error={Boolean(meta.error)}>
                <InputLabel htmlFor={id}>{label}</InputLabel>
                <Select
                  value={input.value}
                  id={id}
                  fullWidth
                  onChange={(e) => {
                    console.log(e.target.value);
                    input.onChange && input.onChange(e.target.value);
                  }}
                >
                  {options.map((item) => {
                    if (!item.value) {
                      return <ListSubheader key={"cat_" + item.text}>{item.text}</ListSubheader>;
                    } else {
                      return (
                        <MenuItem key={"opt_" + item.value} value={item.value}>
                          {item.text}
                        </MenuItem>
                      );
                    }
                  })}
                </Select>
              </FormControl>

              <MetaError className={classes.error} meta={meta} />
            </div>
          );
        }}
      </Field>
    </div>
  );
}

export default withStyles(styles)(GroupSelect);
